
import Navigation from "./Navigation"
import Profile from "./Profile";
import RegisterAlians from "./RegisterAlians";
import AliansPopup from "./AliansPopup";
import UsersTabs from "./UsersTabs";
import AliansValidation from "./AliansValidation";
import AjaxSearch from "./AjaxSearch";
import JoinAlians from "./JoinAlians";

const app = {
	onResize: () => {
	},
	
	onScroll: () => {
	},
	
	init: () => {

    Navigation.init()
    Profile.init()
    RegisterAlians.init()
    AliansPopup.init()
    UsersTabs.init()
    AliansValidation.init()
	  AjaxSearch.init()
    JoinAlians.init()
	}
};

document.addEventListener("DOMContentLoaded", () => {
	app.init();
	
	window.addEventListener("resize", app.onResize);
	window.addEventListener("scroll", app.onScroll);
	window.dispatchEvent(new Event("resize"));
	window.dispatchEvent(new Event("scroll"));
});
